import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import OrderActionCreator from '../actions/OrderActionCreator';

const _orderStatementEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/{scope-id}/{account-id}/statement/order';
const _orderChequeEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/{scope-id}/{account-id}/books/cheque';
const _orderPayinEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/{scope-id}/{account-id}/books/payin';

const scope_id = 'default';

const OrderApiUtils = {
  // from Alerts
  placeOrder(obj) {
    let url;
    let version;
    const method = 'POST';
    switch (obj.type) {
      case 'orderStatement':
        url = envConfig.apiBaseUrlPAAS + _orderStatementEndPoint;
        version = config.apiVersions.orderStatement;
        break;
      case 'orderCheque':
        url = envConfig.apiBaseUrlPAAS + _orderChequeEndpoint;
        version = config.apiVersions.orderCheque;
        break;
      case 'orderPayin':
        url = envConfig.apiBaseUrlPAAS + _orderPayinEndpoint;
        version = config.apiVersions.orderPayin;
        break;
    }
    url = url
      .replace('{scope-id}', scope_id)
      .replace('{account-id}', obj.accountId);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: version,
        method,
        url,
        addAuthToken: true,
      },
      (body, status) => {
        OrderActionCreator.ordersSuccess(obj.type, status);
      },
      (error, status) => {
        OrderActionCreator.ordersFailure(obj.type, status, error);
      }
    );
  },
};
export default OrderApiUtils;
